import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-legacy-palette',
  templateUrl: './legacy-palette.component.html',
  styleUrls: ['./legacy-palette.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class LegacyPaletteComponent implements AfterViewInit {

  @ViewChild('palette') palette: ElementRef<HTMLDivElement>;
  @ViewChild('preview') preview: ElementRef<HTMLDivElement>;

  private _lastColor: string = 'FFF';

  private _color: string = 'FFF';
  @Input()
  public set color(color: string) {
    this._color = color;
    if (this._color === '') {
      this.cdr.detectChanges();
      return;
    }
    if(this._color.substring(0,1)==='#') this._color = this._color.substring(1);
    if(!this.preview) return;
    this.preview.nativeElement.style.setProperty('--swatch-color', '#'+this._color);
    this.preview.nativeElement.style.setProperty('--swatch-label', `#"${this._color}"`);
    this._lastColor = this._color;
    this.colorChange.emit(this._color);
    this.cdr.detectChanges();
  }
  public get color(): string {
    return this._color;
  }

  @Output()
  public colorChange = new EventEmitter<string>();

  constructor(private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    const variants = ['0', '3', '6', '9', 'C', 'F'];
    const revVariants = variants.slice(0).reverse();
    let count = 0;
    let rowCount = -1;
    for (const g of revVariants) {
      rowCount++;
      switch (rowCount) {
        case 0:
          this.MakeSwatch('#FF0000');
          this.MakeSwatch('#FFFFFF');
          break;
        case 1:
          this.MakeSwatch('#FF6600');
          this.MakeSwatch('#CCCCCC');
          break;
        case 2:
          this.MakeSwatch('#FFFF00');
          this.MakeSwatch('#999999');
          break;
        case 3:
          this.MakeSwatch('#00FF00');
          this.MakeSwatch('#666666');
          break;
        case 4:
          this.MakeSwatch('#3366FF');
          this.MakeSwatch('#333333');
          break;
        case 5:
          this.MakeSwatch('#663399');
          this.MakeSwatch('#000000');
          break;
      }
      for (const r of variants) {
        for (const b of revVariants) {
          count += 1;
          const color = r + r + g + g + b + b;
          this.MakeSwatch(color);
        }
      }
    }
    this.color = this._color;
  }
  MakeSwatch(color: string) {
    const template = document.createElement('template');
    template.innerHTML = `<span class="swatch" title="#${color}" style="--swatch-color:#${color}"></span>`;
    const node = template.content.firstChild;
    node.addEventListener('click', (event) => {
      this.SetPreview((event.target as HTMLSpanElement).title);
    });
    node.addEventListener('mouseover', (event) => {
      this.HoverShow((event.target as HTMLSpanElement).title);
    });
    node.addEventListener('mouseleave', (event) => {
      this.UnShow();
    });
    this.palette.nativeElement.appendChild(node);

  }

  SetPreview(color: string) {
    this._lastColor = color;
    // color = color.split('#').pop();
    this.color = color;//(color.length === 6) ? '#'+color : `#${color[0]}${color[0]}${color[1]}${color[1]}${color[2]}${color[2]}`;

  }
  HoverShow(color) {
    this.preview.nativeElement.style.setProperty('--swatch-color', color);
    this.preview.nativeElement.style.setProperty('--swatch-label', `"${color}"`);
  }

  UnShow() {
    this.preview.nativeElement.style.setProperty('--swatch-color', this._lastColor);
    this.preview.nativeElement.style.setProperty('--swatch-label', `"${this._lastColor}"`);
  }
}
